import styled from 'vue3-styled-components';

export const VirtualAccountContainer = styled.div`
  overflow: hidden;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  box-sizing: border-box;
`;

export const Title = styled.h2`
  font-size: 25px;
  text-align: center;
  margin-bottom: 30px;
  color: #cc5803;
`;

export const NoticeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
  font-size: 15px;
`;

export const HistoryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  border: 1px solid #e9ecef;
`;

export const Th = styled.th`
  background: #ddd;
  text-align: center;
  border-bottom: 2px solid #e9ecef;
  font-size: 15px;
`;

export const Td = styled.td`
  padding: 8px;
  text-align: center;
  font-size: 15px;
`;

export const InputContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const Input = styled.input`
  width: 90%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #4dabf7;
    box-shadow: 0 0 0 2px rgba(77,171,247,0.2);
  }
`;

export const Select = styled.select`
  width: 90%;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #4dabf7;
  }
`;

export const TextArea = styled.textarea`
  width: 90%;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  min-height: 90px;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #4dabf7;
    box-shadow: 0 0 0 2px rgba(77,171,247,0.2);
  }
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${props =>
    props.status === 'completed' ? '#d3f9d8' :
      props.status === 'sent' ? '#cce5ff' : '#fff3bf'};
  color: ${props =>
    props.status === 'completed' ? '#2b8a3e' :
      props.status === 'sent' ? '#004085' : '#e67700'};
`;

export const ItemsContainer = styled.div`
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px;
  background: #f8f9fa;
  margin-top: 4px;
`;

export const ItemCard = styled.div`
  background: white;
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 4px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
  font-size: 0.9em;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ItemInfo = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const ItemName = styled.span`
  font-weight: 500;
  color: #333;
  font-size: 0.9em;
`;

export const ItemDetails = styled.div`
  display: flex;
  gap: 4px;
  white-space: nowrap;
`;

export const DetailBadge = styled.span`
  background: #f1f3f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.85em;
  color: #495057;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  gap: 10px;
`;

export const SubmitButton = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #2563eb;
  }
`;

export const CancelButton = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background-color: #6b7280;
  color: white;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4b5563;
  }
`;

export const CustomerHistoryButton = styled.button`
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    padding: 4px 8px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.1s;
    z-index: 1;

    &:hover {
        background-color: #45a049;
    }
`;

export const ErrorMessage = styled.div`
  border-color: #dc2626;
  color: #dc2626;
  font-size: 12px;
  margin-top: 4px;
  display: block;
`;

export const RedSpan = styled.span`
  color: #dc2626;
  margin-right: 4px;
`;

export const MobileCheckMessage = styled.div`
  margin-top: 5px;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: #fb8b24;
`;
